import React from 'react'
import clients from "../../../assets/images/clients.png"

const styles = {
  imgStyle: `w-full h-full mt-10 sm:mt-0 sm:w-8/12 sm:h-3/5`
}

const Client = () => {
  return (
    <div className="w-full centerContent mt-7 sm:mb-16 sm:mt-0">
        <img src={clients} alt="clients" className={styles.imgStyle} />
    </div>
  )
}

export default Client